import Vue from 'vue';
import Vuex from 'vuex';

import membershipStoreModule from '@/store/modules-caas/membershipStore.js';
import companyStoreModule from '@/store/modules-caas/companyStore.js';
import monitoringStoreModule from '@/store/modules-caas/monitoringStore.js';
import partnerStoreModule from '@/store/modules-caas/partnerStore.js';
import dbBrokerStoreModule from '@/store/modules-caas/dbBrokerStore.js';
import reportStoreModule from '@/store/modules-caas/reportStore.js';
import folderStoreModule from '@/store/modules-caas/folderStore.js';
import communicationStoreModule from '@/store/modules-caas/communicationStore.js';
import codeTableStoreModule from '@/store/modules-caas/codeTableStore.js';
import integrationSetStoreModule from '@/store/modules-caas/integrationSetStore.js';
import processStoreModule from '@/store/modules-caas/processStore.js';
import ediIdStoreModule from '@/store/modules-caas/ediIdStore.js';
import userStoreModule from '@/store/modules-caas/userStore.js';
import adminStoreModule from '@/store/modules-caas/adminStore.js';
import menuStoreModule from '@/store/modules-caas/menuStore.js';
import commonStoreModule from '@/store/modules-caas/commonStore.js';
import filterStoreModule from '@/store/modules-caas/filterStore.js';
import converterStoreModule from '@/store/modules-caas/converterStore.js';
import aiClientStoreModule from '@/store/modules-caas/aiClientStore.js';
import dashboardStoreModule from '@/store/modules-caas/dashboardStore.js';
import codesStoreModule from '@/store/modules-caas/codesStore.js';
import sqlGroupStoreModule from '@/store/modules-caas/sqlGroupStore.js';
import dbMaperTestStoreModule from '@/store/modules-caas/dbMapperTestStore.js';
import userCompModule from '@/store/modules-caas/userCompStore.js';
import userSimulatorStoreModule from '@/store/modules-caas/userSimulatorStore.js';
import triggerCompModule from '@/store/modules-caas/triggerCompStore.js';
import workflowGroupStoreModule from '@/store/modules-caas/workflowGroupStore.js';
import dbAdapterModule from '@/store/modules-caas/dbAdapterStore.js';

import dashboard from './modules-dlb/dashboard';
import analysis from './modules-dlb/analysis';
import matching from './modules-dlb/matching';
import layout from './modules-dlb/layout';
import srmlist from './modules-dlb/srmlist';
import fflayout from './modules-dlb/flatfilelayout';
import map from './modules-dlb/map';
import mapbuilder from './modules-dlb/mapbuilder';
import codetable from './modules-dlb/codetable';
import repository from './modules-dlb/repository';
import common from './modules-dlb/common';
import mapdefinition from './modules-dlb/mapdefinition';
import referencefile from './modules-dlb/referencefile';

import paproc from './modules-dlb/paproc';
import createIDBPersist from '../plugins/vuex-idb';

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    createIDBPersist({
      key: 'my-vuex',
      paths: [
        'analysis',
        'matching',
        'layout',
        'srmlist',
        'fflayout',
        'map',
        'mapbuilder',
        'repository',
        'common',
        'mapdefinition',
        'referencefile',
        'codetable',
        'process',
        'communication',
        'user',
        'paproc',
        'monitoring',
        'dbmappertest',
        'dbmap',
        'workFlowGroup',
        'dbAdapter',
      ],
    }),
  ], // !debug ? [createPersistedState({ storage: window.sessionStorage })] : [],
  modules: {
    membership: membershipStoreModule,
    company: companyStoreModule,
    monitoring: monitoringStoreModule,
    partner: partnerStoreModule,
    dbBroker: dbBrokerStoreModule,
    report: reportStoreModule,
    folder: folderStoreModule,
    communication: communicationStoreModule,
    codeTable: codeTableStoreModule,
    integrationSet: integrationSetStoreModule,
    process: processStoreModule,
    ediId: ediIdStoreModule,
    user: userStoreModule,
    admin: adminStoreModule,
    menu: menuStoreModule,
    caascommon: commonStoreModule,
    filter: filterStoreModule,
    converter: converterStoreModule,
    aiClient: aiClientStoreModule,
    caasDashboard: dashboardStoreModule,
    codes: codesStoreModule,
    sqlGroup: sqlGroupStoreModule,
    dbMapperTest: dbMaperTestStoreModule,
    userComp: userCompModule,
    userSimulator: userSimulatorStoreModule,
    triggerComp: triggerCompModule,
    workFlowGroup: workflowGroupStoreModule,
    dbAdapter: dbAdapterModule,
    dashboard: dashboard,
    analysis: analysis,
    matching: matching,
    layout: layout,
    srmlist: srmlist,
    fflayout: fflayout,
    map: map,
    mapbuilder: mapbuilder,
    repository: repository,
    common: common,
    mapdefinition: mapdefinition,
    referencefile: referencefile,
    codetable: codetable,

    paproc: paproc,
  },
});

export default store;
